<template>
  <div class="card-wrap">
    <div class="card-head">
      <label class="label inline-block" style="font-size: 18px;"><input type="checkbox" v-model="checkAll" @click="onCheckAll">全选</label>
      <span class="red margin-left">当前已选择 {{checkCount}} 条数据</span>
    </div>
    <waterfall>
      <div class="waterfall-container">
        <div v-for="(item,index) in list" class="card-item waterfall-item">
          <div v-if="item.isText&&isTopicSearch">
            <button v-if="isTopicSearch" class="button is-info insertText" @click="insertText(item,index)">插入文字</button>
            <button v-if="isTopicSearch" class="button is-info insertVote" @click="insertVote(item,index)">插入投票</button>
            <div class="sort-input" v-if="isTopicSearch">
              <p>排序号</p>
              <input type="number" class="input" @blur="onSort(index)" v-model="item.topicSort">
            </div>
            <div class="textContent">
              <textarea v-if="item.alignStyle==0" v-model="item.content" class="cancelBorder" readonly></textarea>
              <textarea v-if="item.alignStyle==1" v-model="item.content"  :style="{ textAlign: 'center' }" class="cancelBorder" readonly></textarea>
              <textarea v-if="item.alignStyle==2" v-model="item.content"  :style="{ textAlign: 'right' }" class="cancelBorder" readonly></textarea>
            </div>
            <div class="textButton">
              <button class="button is-info  btn-width" @click="editText(item,index)">编辑</button>
              <button class="button is-danger is-outlined  btn-width"  @click="deleteText(item,index)">删除</button>
            </div>
          </div>
          <div v-if="item.isVote&&isTopicSearch">
            <button v-if="isTopicSearch" class="button is-info insertText" @click="insertText(item,index)">插入文字</button>
            <button v-if="isTopicSearch" class="button is-info insertVote" @click="insertVote(item,index)">插入投票</button>
            <article   class="vote-card block">
              <div class="vote-head">
                <span class="fleft" style="font-size: 24px;color: #000">投票</span>
                <span class="fleft margin-left1" v-if="item.type==0" style="background: #000;color: #fff;padding:0px 5px 0px;m">单选</span>
                <span class="fleft margin-left1" v-if="item.type==1" style="background: #000;color: #fff;padding:0px 5px 0px">多选</span>
              </div>
              <div class="sort-input" v-if="isTopicSearch">
                <p>排序号</p>
                <input type="number" class="input" @blur="onSort(index)" v-model="item.topicSort">
              </div>
              <div class="vote-title margin-top">
                <div>
                  <span class="title-con">{{item.title}}</span>
                </div>
              </div>
              <div class="vote-tab">
                <div>
                  <span>票数</span>
                  <span class="color" :class="{'vote-active':item.isShowFake===1}" @click="changeShowFake(1,index)">全部</span>
                  <span class="color" :class="{'vote-active':item.isShowFake===0}" @click="changeShowFake(0,index)">真实</span>
                </div>
              </div>
              <div class="block vote-content">
                <div class=" vote-options">
                  <div  class="vote-item" v-for="(optionItem,optionIndex) in item.options">
                    <div v-if="item.isShowFake">
                      <div class="fleft">
                        <p style="padding-bottom: 10px;">{{optionItem.optionName}}</p>
                        <div>
                          <div class="fleft vote-progress">
                            <div class="true fleft" :style="{'width':(optionItem.voteCount/(item.voteTotalCount+item.fakeTotalCount)*100)+'%'}"></div>
                            <div class="fake fleft" :style="{'width':(optionItem.fakeCount/(item.voteTotalCount+item.fakeTotalCount)*100)+'%'}"></div>
                          </div>
                          <div class="fleft ticket">{{optionItem.voteCount+optionItem.fakeCount}}票</div>
                          <div class="fleft ticket" v-if="(item.voteTotalCount+item.fakeTotalCount)!=0">
                            {{((optionItem.voteCount+optionItem.fakeCount)/(item.voteTotalCount+item.fakeTotalCount)*100).toFixed(2)}}%
                          </div>
                          <div class="fleft ticket" v-else>0.00%</div>
                        </div>

                      </div>

                    </div>
                    <div v-else>
                      <div class="fleft">
                        <p style="padding-bottom: 10px">{{optionItem.optionName}}</p>
                        <div>
                          <div class="fleft vote-progress">
                            <div class="true fleft" :style="{'width':(optionItem.voteCount/item.voteTotalCount*100)+'%'}"></div>
                          </div>
                          <div class="fleft ticket">{{optionItem.voteCount}}票</div>
                          <div class="fleft ticket" v-if="item.voteTotalCount!=0">{{(optionItem.voteCount/item.voteTotalCount*100).toFixed(2)}}%</div>
                          <div class="fleft ticket" v-else>0.00%</div>
                        </div>

                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div>
                {{item.startTime}}~{{item.endTime}}
              </div>
              <div>
                <span v-if="item.showStatus==0" style="background: #1e88e5;color: #fff;padding:2px 5px 2px">未开始</span>
                <span v-if="item.showStatus==1" style="background: #4dc340;color: #fff;padding:2px 5px 2px">开放中</span>
                <span v-if="item.showStatus==2" style="background: #000;color: #fff;padding:2px 5px 2px">已结束</span>
              </div>
              <div style="overflow: hidden">
                <button class='button is-danger fright' @click="deleteVote(item,index)">删除</button>
                <button class="button is-info fright" @click="editVote(item,index)">编辑</button>
              </div>
            </article>
          </div>
          <div v-if="!item.isText&&!item.isVote">
            <button v-if="isTopicSearch" class="button is-info insertText" @click="insertText(item,index)">插入文字</button>
            <button v-if="isTopicSearch" class="button is-info insertVote" @click="insertVote(item,index)">插入投票</button>
            <div class="card-tip">
              {{item.leftDeleteTime | getLeftDeleteTime}}
            </div>
            <!--<div class="inappropriate" v-if="item.status == INAPPROPRIATE_STATUS">不合适</div>-->
            <div class="card-head">
              <div class="check-wrap">
                <label class="label inline-block check-box"><input type="checkbox" v-model="item.checked" @click="onCheckOne"></label>
              </div>
              <div class="sort-input" v-if="isTopicSearch">
                <p>排序号</p>
                <input type="number" class="input" @blur="onSort(index)" v-model="item.topicSort">
              </div>
              <span class="card-type">
              <label class="label inline-block">类型</label>
              <span :class="{'pic':item.articleType == 0,'article':item.articleType == 1}">{{item.articleType | getArticleType}}</span>
            </span>
              <span class="card-ID">
              <label class="label inline-block">ID</label>
              <span>{{item.articleId}}</span>
            </span>
            </div>
            <div class="card-content">
              <div class="blogger-info">
              <span class="avatar">
                <image-component :image="item.avatar" :width="50" :height="50"></image-component>
              </span>
                <span class="blogger-name">
                {{item.name}}
              </span>
              </div>
              <el-input type="textarea" :autosize='{ minRows: 1, maxRows: 3}' v-model="item.content" :readonly='true'></el-input>
              <div class='clearfix'><el-button type="primary" size='small' class='fright' @click='showContentDialog(item.articleId, item.content, index)'>编辑</el-button></div>
              <div class="article-imgs clearfix lightgallery">
                <div v-for="(imgItem,imgIndex) in item.images" class="img-item" :class="{'dash-border':imgItem.checked && rules.imageStatus}" :style="getImgWrapStyle(index)" @click="onImagePreviewClick($event,imgIndex,item.images)">
                  <div class="score" @click.stop="checkImg(index,imgIndex)">{{imgItem.score}}</div>
                  <i class="code-review fa fa-code" aria-hidden="true" @click.stop="onGoAudit(index, imgItem)"></i>
                  <!-- <i class="code-review fa fa-code" aria-hidden="true" @click.stop="onShowCodeModal(index,imgIndex)"></i> -->
                  <image-component :image="imgItem" :width="getImgStyle(imgItem,index).width" :height="getImgStyle(imgItem,index).height" :compress="1.2"></image-component>
                </div>
              </div>
            </div>
            <div class="card-time">
              <p v-if="item.publishTime">{{item.publishTime}} <span class="publish-time">发帖</span></p>
              <p v-if="!item.publishTime">
              <span style="display: inline-block;width:160px;">
                <el-date-picker
                        v-model="item.publishTimeVal"
                        type="datetime"
                        placeholder="发帖时间"
                        align="right">
                </el-date-picker>
              </span>
                <button class="button is-info" @click="doSavePublishTime(index)">发帖</button>
              </p>
              <p v-if="item.verifyTime">{{item.verifyLog && item.verifyLog[0] && item.verifyLog[0].logTime}}
                <span class="verify-time">{{item.verifyLog && item.verifyLog[0] && item.verifyLog[0].log}}</span>
              </p>
              <a class="inline-block margin-top" @click="onShowRecordModal(index)">操作记录</a>
            </div>
            <div class="card-goods">

            </div>
            <div class="card-btn">
              <span><router-link class="button is-outlined is-dark"  target="_blank" :to="{ name: 'articleSimilaryGoods',query:{articleId:item.articleId,searchParams:JSON.stringify(searchParams)}}" >相似商品</router-link><span class="wait-online">({{item.onlineCount}} / {{item.similaryCount}})</span></span>
              <button v-if="item.status == WAIT_VERIFY_STATUS" class="button is-success btn-width" @click="doSaveArticleStatus(index,VERIFYED_STATUS)">放行</button>
              <button v-if="item.status == VERIFYED_STATUS" class="button is-danger btn-width" @click="doSaveArticleStatus(index,WAIT_VERIFY_STATUS)">撤回</button>
              <button class="button is-info  btn-width" @click="doEditArticle(index)">编辑</button>
              <button v-if="item.status !== DELETE_STATUS" class="button is-danger is-outlined  btn-width"  @click="doSaveArticleStatus(index,DELETE_STATUS)">删除</button>
              <button v-if="item.status == DELETE_STATUS" class="button is-info is-outlined  btn-width" @click="doSaveArticleStatus(index,WAIT_VERIFY_STATUS)">恢复</button>
            </div>
            <div class="card-data">
              <label class="label">浏览 {{item.viewCount}}</label>
              <label class="label">点击 {{item.clickCount}}</label>
              <label class="label">分享 {{item.shareCount}}</label>
              <label class="label">真实喜欢数 {{item.collectCount}}</label>
            </div>
            <div class="card-tags">
              <collapse :height='35' @collapse-change='collapseChange'>
                <div class="tag-container">
                <span class="margin-top">
                  <label class="label inline-block r-top">运营标签</label>
                  <button class="button is-info" @click="onShowAddTagsModal('operation',index)">添加</button>
                </span>
                  <span class="tag is-warning is-medium" v-for="(tagItem,tagIndex) in item.operationTags">
                  {{tagItem}}
                  <button class="delete is-small" @click="onDelOperationTag(index,tagIndex)"></button>
                </span>
                </div>
              </collapse>
              <collapse :height='35' @collapse-change='collapseChange'>
                <div class="tag-container">
                <span class="margin-top">
                  <label class="label inline-block r-top">属性标签</label>
                  <button class="button is-info" @click="onShowAddTagsModal('property',index)">添加</button>
                </span>
                  <span class="tag is-warning is-medium" v-for="(tagItem,tagIndex) in item.propertiesTags">
                  {{tagItem | filterTag}}
                  <button class="delete is-small" @click="onDelpropertiesTag(index,tagIndex)"></button>
                </span>
                </div>
              </collapse>
            </div>
          </div>
        </div>
      </div>
    </waterfall>
    <el-dialog :title="modal.title" :visible.sync="modal.visible" :lock-scroll="false">
      <div v-if="modal.type == 'operation'">
        <label class="label">标签名称</label>
        <span class="inline-block">
          <el-select v-model="modal.selectedOperationsTag" multiple filterable allow-create placeholder="请选择">
             <el-option
                     v-for="item in modal.operationTags"
                     :key="item.tagId"
                     :label="item.name"
                     :value="item.name">
             </el-option>
          </el-select>
        </span>
      </div>
      <div v-if="modal.type == 'property'">
        <span class="tag is-warning is-medium" style="border-radius: 5px;margin-left: 5px;" v-for="(tagItem,tagIndex) in modal.valArray">
          {{tagItem}}
          <button class="delete is-small" @click="onDelValArray(tagIndex)"></button>
        </span>
        <label class="label">标签名称</label>
        <input type="text" class="input" v-model="modal.value" @keyup.enter="onKeyup" placeholder="回车之后可以添加多个关联标签">
      </div>
      <div v-if="modal.type == 'batchVerify'">
        <label class="label blue">当前已选中 {{checkCount}} 条动态</label>
        <label class="label margin-left">共计 <span class="red">{{modal.imgCount}}</span> 张图片分数低于 {{rules.score}} 分 ，是否确认放行？</label>
      </div>
      <div v-if="modal.type == 'batchDeleteImg'">
        <label class="label">
          当前红框圈选图片共 <span class="red">{{articleTotalImgCount}}</span> 张，
          <span v-if="modal.articleCount">其中 <span class="red">{{modal.articleCount}}</span> 条动态的图全被删除，</span>
          是否确认删除图片？
        </label>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modal.visible = false;">取 消</el-button>
        <el-button type="primary" @click="MODAL_OK_EVENT">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="Preview" :visible.sync="codeModal.visible" :lock-scroll="false">
      <el-tabs v-model="codeModal.activeTab" type="card">
        <el-tab-pane label="JSON Preview" name="json">
          <json-preview :json-obj="codeModal.codeObj"></json-preview>
        </el-tab-pane>
        <el-tab-pane label="Image Preview" name="image">
          <image-preview :json-obj="codeModal.codeObj"></image-preview>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-dialog title="操作记录" :visible.sync="logModal.visible" :lock-scroll="false">
      <div class="text-center label">
        操作记录
        <router-link class="fright" :to="{name:'operatingRecord',query:{articleId:logModal.articleId}}">查看全部</router-link>
      </div>
      <table class="table is-bordered">
        <thead>
        <tr>
          <th>处理人</th>
          <th>备注</th>
          <th>操作描述</th>
          <th>处理时间</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in logModal.logList">
          <td>{{item.accountName}}</td>
          <td>{{item.remark | filterIsEmpty}}</td>
          <td>{{item.opType | getOptype}}</td>
          <td>{{item.opTime}}</td>
        </tr>
        </tbody>
      </table>
    </el-dialog>
    <el-dialog title='编辑内容' :visible.sync='contentModal.visible' :lock-scroll="false">
      <el-input type="textarea" autosize v-model="contentModal.content"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="contentModal.visible = false">取 消</el-button>
        <el-button type="primary" @click="contentModalOk">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="插入文本" :visible.sync="insertTextModal.visible" :lock-scroll="false">
      <el-form :model="insertTextModal">
        <el-form-item label="排序号" v-if="InsertParams.isEdit">
          <el-input v-model="insertTextModal.topicSort" class="sort"></el-input>
        </el-form-item>
        <el-form-item label="文本区域:" >
          <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请输入内容"
                  :autosize="{minRows: 5, maxRows: 10 }"
                  v-model="insertTextModal.content">
          </el-input>
        </el-form-item>
        <el-form-item label="对齐方式:" >
          <el-radio-group v-model="insertTextModal.alignStyle">
            <el-radio :label="0">左对齐</el-radio>
            <el-radio :label="1">居中对齐</el-radio>
            <el-radio :label="2">右对齐</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelInsertText">取 消</el-button>
        <el-button type="primary" @click="doSaveInsertText">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="插入投票" :visible.sync="insertVoteModal.visible" :lock-scroll="false" width="80%">
      <div class="margin-left">
        <span>从投票库选择</span>
        <el-select v-model="insertVoteModal.voteId" filterable placeholder="请选择" style="width:50%">
          <el-option
                  v-for="item in initTitle"
                  :key="item.voteId"
                  :label="item.title"
                  :value="item.voteId">
          </el-option>
        </el-select>
        <router-link :to="{name: 'votingContentLibrary'}">新增投票</router-link>
      </div>
      <div class="fleft margin-left margin-top">
        <span>开放时间</span>
        <el-date-picker
                v-model="insertVoteModal.startTime"
                type="datetime"
                placeholder="选择开始日期时间">
        </el-date-picker>~
        <el-date-picker
                v-model="insertVoteModal.endTime"
                type="datetime"
                placeholder="选择结束日期时间">
        </el-date-picker>
      </div>
      <div class="fleft margin-left margin-top">
        <span>排序</span>
        <input style="width: 50px;height:40px;" type="number" v-model.number="insertVoteModal.topicSort">
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelInsertVote">取消</el-button>
        <el-button type="primary" @click="doSaveVote(0)">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
    import waterfall from 'COMMON/waterfall/waterfall.vue'
    import TagGroup from 'COMMON/TagGroup';
    import {mapState, mapActions} from 'vuex'
    import {onImagePreviewClick} from 'UTILS/imagePreview'
    import {formatDate} from 'UTILS/date'
    import jsonPreview from 'COMMON/jsonPreview'
    import imagePreview from './imagePreview.vue'
    import {getTimeByDateStr} from 'UTILS/date'
    import Collapse from 'COMMON/Collapse'

    export default {
        components:{
            waterfall,TagGroup,jsonPreview,imagePreview,Collapse
        },
        computed:{
            ...mapState({
                userInfo : state => state.userInfo,
                articleTotalImgCount : state => state.articleTotalImgCount,
            })
        },
        data(){
            return {
                WAIT_VERIFY_STATUS:0, //待放行
                VERIFYED_STATUS:1,   //已放行
                INAPPROPRIATE_STATUS:2, //不合适
                DELETE_STATUS:3, //回收站
                list:[],
                modal:{
                    visible:false,
                    type:'',
                    title:'',
                    value:'',
                    index:'',
                    valArray:[],
                    selectedOperationsTag:[],
                    operationsTag:[],
                    bodyStyle:{},
                    imgCount:0,
                    articleIds:[],
                    hasPublishTimeOfNull:false,
                    articleCount:0,
                    checkImgs:{}
                },
                codeModal:{
                    visible:false,
                    bodyStyle:{},
                    codeObj:{},
                    activeTab:'json'
                },
                logModal:{
                    visible:false,
                    logList:[],
                    articleId:''
                },
                contentModal: {
                    visible: false,
                    content: '',
                    id: '',
                    index: ''
                },
                insertTextModal:{
                    visible:false,
                    topicSort:0,
                    content:'',
                    articleId:0,
                    alignStyle:2,// 0左对齐，1居中，2右对齐
                },
                InsertParams:{
                    /* topicId:null,
                     content:null,
                     alignStyle:null,
                     frontArticleTime:null,
                     frontArticleSort:null,
                     nextArticleTime:null,
                     nextArticleSort:null,
                     isEdit:0,*/
                },
                publishTime:'',
                checkAll:false,
                checkCount:0,
                tempIndex:null,
                insertVoteModal:{
                    visible:false,
                    voteId:null,
                    startTime:'',
                    endTime:'',
                    topicSort:'',
                },
                initTitle:[],
                topicId:null,
            }
        },
        mounted(){
            this.topicId=this.$route.query.topicId
            this.list = JSON.parse(JSON.stringify(this.source));
            this.commitWaterfallUpdate(true)
            if(this.isTopicSearch){
                this.init()
            }
        },
        watch:{
            "modal.visible"(){
                this.modal.value = "";
                this.modal.valArray = [];
                if(!this.modal.visible){
                    this.modal.operationsTag = [];
                }
            },
            source(){
                this.list = JSON.parse(JSON.stringify(this.source));
                this.commitWaterfallUpdate(true)
            },
        },
        props:{
            source:{
                type:Array,
                default:[]
            },
            allOperationTag:{
                type:Array
            },
            searchStatus:{
                type:Array,
                require:true,
            },
            searchParams:Object,
            rules:Object,
            isTopicSearch:Boolean
        },
        methods:{
            ...mapActions([
                'commitWaterfallUpdate','updateArticleImgCount', 'commitCollapseUpdate'
            ]),
            changeShowFake(num,index){
                if(this.list[index].isShowFake!==num){
                    this.list[index].isShowFake=num;
                }
            },
            deleteVote(item,index){
                if(!confirm("确认删除?")){
                    return false;
                }
                let params={
                    topicId:item.topicId,
                    articleId:item.articleId,
                    isVote:1,
                }
                HttpRequest.get('/admin.php?method=blogger.removeTopicVote',params).then(response => {
                    if(response.data.success==1){
                        this.$message("删除成功")
                        this.list.splice(index,1);
                        this.commitWaterfallUpdate(true);
                    }
                })
            },
            init(){
                HttpRequest.get('/admin.php?method=fashion.getVoteList').then(response => {
                    this.initTitle = _.toArray(response.data.list);
                })
            },
            insertVote(item,index){
                this.insertVoteModal.visible=true;
                this.insertVoteModal.voteId=null;
                this.insertVoteModal.startTime='';
                this.insertVoteModal.endTime='';
                this.insertVoteModal.topicSort='';
                this.insertVoteModal.topicId=item.topicId;
                this.InsertTimeParams(item,index);
            },
            editVote(item,index){
                this.insertVoteModal.visible=true;
                this.insertVoteModal.voteId=item.voteId;
                this.insertVoteModal.startTime=new Date(item.startTime);
                this.insertVoteModal.endTime=new Date(item.endTime);
                this.insertVoteModal.topicSort=item.topicSort;
                this.insertVoteModal.articleId=item.articleId;
                this.insertVoteModal.topicId=item.topicId;
                this.InsertParams.isEdit=1;
                this.tempIndex=index;

            },
            doSaveVote(){
                let params={
                    topicId:this.insertVoteModal.topicId,
                    voteId:this.insertVoteModal.voteId,
                    startTime:getTimeByDateStr(this.insertVoteModal.startTime),
                    endTime:getTimeByDateStr(this.insertVoteModal.endTime),
                }
                if(this.insertVoteModal.topicSort.length!==0){
                    params.topicSort=this.insertVoteModal.topicSort
                }
                if(!params.startTime){
                    params.startTime=getTimeByDateStr(new Date())
                }
                if(!params.endTime){
                    params.endTime="2030-10-01 00:00:00"
                }
                if(this.InsertParams.isEdit){
                    this.InsertParams.articleId= this.insertVoteModal.articleId;
                    this.InsertParams.publishTime= this.list[this.tempIndex].publishTime;
                }
                Object.assign(params,this.InsertParams)
                if(!params.voteId){
                    this.$message("请选择标题")
                    return;
                }
                HttpRequest.get('/admin.php?method=blogger.DoSaveTopicVote',params).then(response => {
                    if(response.data.success){
                        this.insertVoteModal.visible=false;
                        this.$message('保存成功');
                        if(this.InsertParams.isEdit){
                            this.list[this.tempIndex].voteId=params.voteId;
                            this.list[this.tempIndex].startTime=params.startTime;
                            this.list[this.tempIndex].endTime=params.endTime;
                            this.list[this.tempIndex].topicSort=params.topicSort;
                            if(new Date(params.startTime) > new Date()){
                                this.list[this.tempIndex].showStatus=0;
                            }else if(new Date(params.endTime) < new Date()){
                                this.list[this.tempIndex].showStatus=2;
                            }else{
                                this.list[this.tempIndex].showStatus=1;
                            }
                        }else{
                            let scrollTop = $(document).scrollTop();
                            this.$emit("update-article-list",scrollTop)
                            this.commitWaterfallUpdate(true);
                        }
                    }
                })
            },
            cancelInsertVote(){
                this.InsertParams.isEdit=0;
                this.insertVoteModal.visible=false;
            },
            insertText(item,index){
                this.insertTextModal.content="";
                this.insertTextModal.alignStyle=0;
                this.insertTextModal.visible=true;
                this.insertTextModal.topicId=item.topicId;
                console.log(item.topicId)
                this.InsertTimeParams(item,index);
            },
            /*
            * 插入文字和插入投票公用部分
            * */
            InsertTimeParams(item,index){
                let tempTime=null;
                if(index===0){
                    tempTime=new Date();
                    tempTime.setTime(new Date(this.list[index].publishTime).getTime()+1000);
                }
                this.InsertParams.isEdit=0;
                this.InsertParams.frontArticleTime=this.list[index-1]?this.list[index-1].publishTime:formatDate(+tempTime);
                this.InsertParams.frontArticleSort=this.list[index-1]?this.list[index-1].topicSort:this.list[index].topicSort;
                this.InsertParams.nextArticleTime=this.list[index].publishTime;
                this.InsertParams.nextArticleSort=this.list[index].topicSort;
            },
            editText(item,index){
                this.insertTextModal.topicSort=item.topicSort;
                this.insertTextModal.content=item.content;
                this.insertTextModal.topicId=item.topicId;
                this.insertTextModal.alignStyle=item.alignStyle;
                this.insertTextModal.articleId=item.articleId;
                this.InsertParams.isEdit=1;
                this.insertTextModal.visible=true;
                this.tempIndex=index;
            },
            doSaveInsertText(){
                let params={
                    topicId:this.insertTextModal.topicId,
                    content:this.insertTextModal.content,
                    alignStyle:this.insertTextModal.alignStyle,
                }
                if(this.InsertParams.isEdit){
                    this.InsertParams.topicSort= this.insertTextModal.topicSort;
                    this.InsertParams.articleId= this.insertTextModal.articleId;
                    this.InsertParams.publishTime= this.list[this.tempIndex].publishTime;
                }
                Object.assign(params,this.InsertParams)
                if(!params.content){
                    this.$message("内容不能为空，请输入内容")
                    return;
                }
                this.insertTextModal.visible=false;
                console.log(params)
                HttpRequest.post('/admin.php?method=blogger.doSaveText',params).then(response => {
                    if(response.data.success){
                        this.$message("保存成功");
                        if(this.InsertParams.isEdit){
                            this.list[this.tempIndex].content=params.content
                            this.list[this.tempIndex].alignStyle=params.alignStyle
                        }else{
                            let scrollTop = $(document).scrollTop();
                            this.$emit("update-article-list",scrollTop)
                            this.commitWaterfallUpdate(true);
                        }
                        this.InsertParams={};

                    }else{
                        this.$message(response.msg)
                    }
                })
            },
            cancelInsertText(){
                this.InsertParams.isEdit=0;
                this.insertTextModal.visible=false;
            },

            deleteText(item,index){
                if(!confirm("确认删除?")){
                    return false;
                }
                let params={
                    topicId:item.topicId,
                    articleId:item.articleId,
                    isText:1,
                }
                HttpRequest.post("/admin.php?method=blogger.doDeleteArticle",params).then(response => {
                    if(response.data.success){
                        this.$message("删除成功！")
                        this.list.splice(index,1);
                        this.commitWaterfallUpdate(true);

                    }
                })
            },
            contentModalOk() {
                this.contentModal.visible = false
                let params = {
                    articleId: this.contentModal.articleId,
                    content: this.contentModal.content
                }
                this.list[this.contentModal.index].content = this.contentModal.content
                HttpRequest.post('/admin.php?method=fashion.doSaveArticleContent',params)
            },
            showContentDialog(articleId, content, index) {
                this.contentModal.visible = true
                this.contentModal.content = content
                this.contentModal.articleId = articleId
                this.contentModal.index = index
            },
            collapseChange() {
                this.commitWaterfallUpdate(true)
            },
            getImgWrapStyle(index){
                if(_.toArray(this.list[index].images).length > 2){
                    return {
                        width:'100px',
                        height:'100px'
                    }
                }
                return {};
            },
            getImgStyle(img,index){
                if(_.toArray(this.list[index].images).length > 2){
                    return {
                        width:100,
                        height:100
                    };
                }
                return {
                    width:150,
                    height:200
                }

            },
            onShowAddTagsModal(type,index){
                if(type == 'operation'){
                    this.modal.title = "添加运营标签";
                    this.modal.bodyStyle = {
                        'overflow-x': 'initial',
                        'overflow-y': 'initial'
                    }
                }else if(type == 'property'){
                    this.modal.title = "添加属性标签";
                    this.modal.bodyStyle = {}
                }
                this.modal.type = type;
                this.modal.index = index;
                this.modal.operationTags = _.toArray(this.allOperationTag)
                this.modal.selectedOperationsTag = _.toArray(this.list[index].operationTags);
                this.modal.visible = true;
            },
            updateModalOperationTag(obj){
                if(!obj){
                    this.modal.selectedOperationsTag = []
                    return false
                }
                let arr = [],
                    isRepeat = false;
                _.each(obj,item => {
                    if(typeof item !== "string"){
                        if(arr.indexOf(item.name) === -1){
                            arr.push(item.name)
                        }else {
                            isRepeat = true
                        }
                    }else {
                        if(arr.indexOf(item) === -1){
                            arr.push(item)
                        }else {
                            isRepeat = true
                        }
                    }
                })
                if(isRepeat){
                    this.$message("添加失败，当前有重复的标签，已经过滤~")
                }
                this.modal.selectedOperationsTag = arr
            },
            /**
             * 添加新运营标签
             */
            addCustomTags(obj){
                this.modal.selectedOperationsTag.push(obj)
                let tagId = this.allOperationTag.length + 1
                this.modal.operationTags.push({
                    tagId : tagId,
                    name : obj
                })
            },
            /**
             * 删除运营标签
             * @param index
             * @param tagIndex
             */
            onDelOperationTag(index,tagIndex){
                this.list[index].operationTags.splice(tagIndex,1);
                let params = {
                    articleId:this.list[index].articleId,
                    type : 0,
                    tags : this.list[index].operationTags
                }
                this.doSaveTags(params);
            },
            /**
             * 删除属性标签
             * @param index
             * @param tagIndex
             */
            onDelpropertiesTag(index,tagIndex){
                this.list[index].propertiesTags.splice(tagIndex,1);
                let params = {
                    articleId:this.list[index].articleId,
                    type : 1,
                    tags : this.list[index].propertiesTags
                }
                this.doSaveTags(params);
            },
            /**
             * 保存标签
             */
            doSaveTags(params){
                HttpRequest.post('/admin.php?method=blogger.doSaveTags',params).then(response => {
                    if(response.data.success){
                        this.$emit("updateOperationsTagEvent")
                        this.modal.visible = false
                    }else{
                        this.$message(response.data.msg)
                    }
                })
                this.commitWaterfallUpdate(true);
                this.commitCollapseUpdate(true)
            },
            /**
             * 回车添加属性标签
             */
            onKeyup(){
                let index = this.modal.index,
                    value = this.modal.value.trim();
                if(value && this.modal.valArray.indexOf(value) === -1){
                    this.modal.valArray.push(value)
                }else if(this.modal.valArray.indexOf(value) > -1){
                    this.$message("不能关联重复的标签，已过滤~~")
                }
                this.modal.value = "";
            },
            /**
             * 弹窗中的关联标签删除
             * @param index
             */
            onDelValArray(index){
                this.modal.valArray.splice(index,1);
            },
            /**
             * 根据是否关联标签来区分标签的颜色
             */
            getTagColor(tagItem){
                if(typeof tagItem == "object"){
                    return {
                        "border":'3px dashed #569ff7'
                    }
                }
                return {}
            },
            doSaveArticleStatus(index,status){
                if(!this.list[index].publishTime && status === this.VERIFYED_STATUS){
                    this.$message("放行失败！请先配置发帖时间！")
                    return false
                }
                let articleId =  this.list[index].articleId;
                HttpRequest.post('/admin.php?method=blogger.doSaveStatus',{articleIds:[articleId],status:status}).then(response => {
                    if(response.data.success){
                        this.list[index].status = status;
                        if(status === this.VERIFYED_STATUS){//如果是进行放行操作，则实时更新verifyLog
                            this.list[index].verifyTime = +new Date()
                            Array.prototype.unshift.call(this.list[index].verifyLog,{
                                logTime:formatDate(+new Date()),
                                log:this.userInfo.username+"放行"
                            })
                        }else if(status === this.WAIT_VERIFY_STATUS){
                            this.list[index].verifyTime = 0
                        }
                        this.filterArticleByStatus(index,this.searchStatus,status)
                        this.commitWaterfallUpdate(true);
                    }
                })
            },
            onShowBatchVerifyModal(){
                let articleIds = [],
                    hasPublishTimeOfNull = false,
                    params = {},
                    imgCount = 0
                _.each(this.list, item => {
                    if(item.publishTime && item.checked){
                        articleIds.push(item.articleId)
                        _.each(item.images, imgItem => {
                            if(imgItem.score < this.rules.score){
                                imgCount++
                            }
                        })
                    }else if(!item.publishTime){
                        item.checked = false
                        hasPublishTimeOfNull = true
                    }
                })
                this.modal.type = 'batchVerify'
                this.modal.title = '提示'
                this.modal.imgCount = imgCount
                this.modal.articleIds = articleIds
                this.modal.hasPublishTimeOfNull = hasPublishTimeOfNull
                if(!articleIds.length){
                    this.$message("当前未勾选动态，无法放行！")
                    return false
                }

                this.modal.visible = true
            },
            /**
             * 批量放行
             */
            doBatchVerify(){
                if(this.modal.hasPublishTimeOfNull){
                    this.$message("存在没有发帖时间的动态，已过滤~")
                }
                let params = {
                    articleIds:this.modal.articleIds,
                    status:this.VERIFYED_STATUS
                }
                HttpRequest.post('/admin.php?method=blogger.doSaveStatus',params).then(response => {
                    if(response.data.success){
                        _.each(this.modal.articleIds, articleId => {
                            for(let i = this.list.length - 1; i >= 0; i--){
                                let item = this.list[i]
                                if(item.articleId === articleId){
                                    item.status = this.VERIFYED_STATUS
                                    this.filterArticleByStatus(i,this.searchStatus,this.VERIFYED_STATUS)
                                    this.commitWaterfallUpdate(true);
                                }
                            }
                        })
                        this.checkAll = false
                        this.checkCount = 0
                    }
                })
            },
            onShowDeleteImgModal(){
                if(!this.articleTotalImgCount || !this.rules.imageStatus){
                    this.$message("当前未红框图片，请先圈选图片！")
                    return false
                }
                this.modal.type = "batchDeleteImg"
                let articleCount = 0,
                    checkImgs = {},
                    tempObj = {}
                _.each(this.list, item => {
                    let checkCount = 0
                    _.each(item.images, imgItem => {
                        if(imgItem.checked){
                            checkCount++
                            if(!checkImgs[item.articleId]){
                                checkImgs[item.articleId] = []
                            }
                            tempObj = {}
                            for(let k in imgItem){
                                if(k != 'checked'){
                                    tempObj[k] = imgItem[k]
                                }
                            }
                            checkImgs[item.articleId].push(tempObj)
                        }
                    })
                    if(checkCount !== 0 && checkCount === _.size(item.images)){
                        articleCount++
                    }
                })
                this.modal.checkImgs = checkImgs
                this.modal.articleCount = articleCount
                this.modal.visible = true
            },
            doBatchDeleteImg(){
                HttpRequest.post("/admin.php?method=fashion.deleteArticleImage",{images:JSON.stringify(this.modal.checkImgs)}).then(response => {
                    if(response.data.success){
                        this.$message("批量删除图片成功！")
                        this.doDeleteImgByChecked()
                        this.checkImgByImgScore()
                        this.modal.visible = false
                    }
                })
            },
            doDeleteImgByChecked(){
                _.each(this.list, item => {
                    for(let i = item.images.length - 1; i >= 0; i--){
                        if(item.images[i].checked){
                            item.images.splice(i,1)
                        }
                    }
                })
            },
            /**
             * 根据当前筛选项的状态来过滤操作项
             */
            filterArticleByStatus(index,searchStatus,status){
                if(searchStatus.length && searchStatus.indexOf(status.toString()) === -1){
                    this.list.splice(index,1)
                    if(!this.list.length){
                        this.$emit("updateArticleList")
                    }
                }
            },
            doSavePublishTime(index){
                let params = {
                    articleId : this.list[index].articleId,
                    publishTime : getTimeByDateStr(this.list[index].publishTimeVal)
                }
                HttpRequest.post("/admin.php?method=fashion.doSavePublishTime",params).then(response => {
                    if(response.data.success){
                        this.$message("发帖时间设置成功")
                        this.list[index].publishTime = this.list[index].publishTimeVal
                    }
                })
            },
            /**
             * 过滤重复标签
             * @param targetArr
             * @returns {boolean} 是否有重复标签
             */
            uniq(targetArr){
                let dic = {},isRepeat = false
                _.each(targetArr,(item,index) => {
                    if(dic[item] == 1){
                        targetArr.splice(index,1)
                        isRepeat = true
                    }else{
                        dic[item] = 1
                    }
                })
                return isRepeat
            },
            onImagePreviewClick:onImagePreviewClick,
            /**
             * 编辑
             * @param index
             */
            doEditArticle(index){
                let item = this.list[index],
                    scrollTop = $(document).scrollTop();
                this.$router.push({
                    path: 'articleEdit',
                    query: {
                        status: item.status,
                        articleId:item.articleId,
                        articleType: item.articleType,
                        scrollTop:scrollTop,
                        searchParams : JSON.stringify(this.searchParams)
                    }
                })
            },
            /**
             * 相似商品
             */
            goSimilaryGoods(index){
                let item = this.list[index],
                    scrollTop = $(document).scrollTop();
                this.$router.push({
                    path:'articleSimilaryGoods',
                    query:{
                        articleId:item.articleId,
                        scrollTop:scrollTop,
                        searchParams:JSON.stringify(this.searchParams)
                    }
                })
            },
            /**
             * 展示代码reviewModal
             * @param index
             * @param imgIndex
             */
            onShowCodeModal(index,imgIndex){
                let articleId = this.list[index].articleId,
                    modalHeight = $(window).height()-50
                if(this.list[index].feedDetect && this.list[index].feedDetect[imgIndex]){
                    this.codeModal.codeObj = this.getFeedDetectByImgUrl(this.list[index].images[imgIndex].image,this.list[index].feedDetect)
                    this.codeModal.visible = true
                    return false
                }
                HttpRequest.get('/admin.php?method=blogger.getFeedDetect',{articleId:articleId}).then(response => {
                    this.list[index].feedDetect = _.toArray(response.data)
                    this.codeModal.codeObj = this.getFeedDetectByImgUrl(this.list[index].images[imgIndex].image,this.list[index].feedDetect)
                    this.codeModal.bodyStyle = {
                        "max-height":modalHeight+'px',
                        "height":modalHeight+'px'
                    }
                    this.codeModal.visible = true
                })
            },
            getFeedDetectByImgUrl(url,feedDetect){
                let detect = {}
                _.each(feedDetect,item => {
                    if(item.image === url){
                        detect = item
                    }
                })
                return detect
            },
            onCheckAll(){
                setTimeout(()=>{
                    if(this.checkAll){
                        _.each(this.list,item => {
                            item.checked = true
                        })
                        this.checkCount = this.list.length;
                    }else {
                        _.each(this.list,item => {
                            item.checked = false
                        })
                        this.checkCount = 0
                    }
                },0)
            },
            onCheckOne(){
                setTimeout(()=>{
                    let checkCount = 0
                    _.each(this.list,item => {
                        if(item.checked){
                            checkCount++
                        }
                    })
                    this.checkCount = checkCount
                    if(checkCount !== this.list.length){
                        this.checkAll = false
                    }else{
                        this.checkAll = true
                    }
                },0)
            },
            onShowRecordModal(index){
                let articleId = this.list[index].articleId,
                    params = {
                        articleId:articleId,
                        page:1,
                        pageSize:20
                    }
                this.logModal.visible = true
                this.logModal.articleId = articleId
                HttpRequest.get('/admin.php?method=fashion.getOpRecordList',params).then(response => {
                    this.logModal.logList = _.toArray(response.data.list)
                })
            },
            /**
             * 通过设置的图片分数来圈选图片
             */
            checkImgByImgScore(){
                this.updateArticleImgCount(0)
                _.each(this.list, item => {
                    _.each(item.images, imgItem => {
                        if(imgItem.score && imgItem.score < this.rules.imageScore){
                            imgItem.checked = true
                            this.updateArticleImgCount(1)
                        }else {
                            imgItem.checked = false
                        }
                    })
                })
            },
            checkImg(index,imgIndex){
                if(!this.rules.imageStatus) return false;
                let checked = this.list[index].images[imgIndex].checked
                if(checked){
                    this.list[index].images[imgIndex].checked = false
                    this.updateArticleImgCount(-1)
                }else{
                    this.list[index].images[imgIndex].checked = true
                    this.updateArticleImgCount(1)
                }
            },
            onSort(index){
                let item = this.list[index],
                    params = {
                        topicId:item.topicId,
                        articleId:item.articleId,
                        sort:item.topicSort
                    }
                HttpRequest.post('/admin.php?method=fashion.doSaveArticleTopicSort',params).then(response => {
                    if(response.data.success){
                        this.$message("设置成功！")
                    }
                })
            },
            /**
             * 添加属性标签
             */
            MODAL_OK_EVENT(){
                let index = this.modal.index;
                let params = {};
                if(this.modal.type == 'operation'){
                    this.list[index].operationTags = this.modal.selectedOperationsTag;
                    params = {
                        articleId:this.list[index].articleId,
                        type : 0,
                        tags : this.modal.selectedOperationsTag
                    }
                    this.doSaveTags(params);
                    this.commitWaterfallUpdate(true);
                    this.commitCollapseUpdate(true)
                }else if(this.modal.type == "property"){
                    let propTags = _.toArray(JSON.parse(JSON.stringify(this.list[index].propertiesTags)));
                    if(this.modal.valArray.length > 0){
                        propTags.push(...this.modal.valArray);
                    }else if(this.modal.valArray.length == 0 && this.modal.value.trim()){
                        propTags.push(this.modal.value);
                    }
                    if(this.uniq(propTags)) this.$message("当前有重复的标签，已经过滤~~")
                    this.list[index].propertiesTags = propTags;
                    params = {
                        articleId:this.list[index].articleId,
                        type : 1,
                        tags : propTags
                    }
                    this.doSaveTags(params);
                    this.commitWaterfallUpdate(true);
                    this.commitCollapseUpdate(true)
                }else if(this.modal.type == 'batchVerify'){
                    this.doBatchVerify()
                }else if(this.modal.type == 'batchDeleteImg'){
                    this.doBatchDeleteImg()
                }
            },
            onGoAudit(_index, _params) {
                let scrollTop = $(document).scrollTop();
                this.$router.push({
                    name: 'pictureSettings',
                    query: {
                        fromWhere: 'article',
                        image: _params.image,
                        score: _params.score,
                        scrollTop:scrollTop,
                        searchParams:JSON.stringify(this.searchParams)
                    }
                })
            }
        },
        filters:{
            getArticleType(type){
                if(type == 0){
                    return "图集";
                }else if(type == 1){
                    return "文章";
                }
            },
            getLeftDeleteTime(time){
                if(time <= 0){
                    return '';
                }
                let day = Math.ceil(time / (3600*24));
                return `${day}天后彻底删除`;
            },
            getOptype(opType){
                var optTypeList = {
                    0:'撤回',
                    1:'放行',
                    2:'编辑',
                    3:'删除',
                    4:'恢复'
                }
                return optTypeList[opType]
            },
            filterIsEmpty(value){
                return value ? value : "-"
            },
            filterTag(value){
                if(typeof value === 'object'){
                    let tags = ""
                    _.each(value,item => {
                        tags += item + ' '
                    })
                    return tags
                }
                return value
            }
        }
    }
</script>
<style lang="less" scoped>
  .card-wrap {
    .el-input.sort{
      width:100px;
    }
    .card-head {
      height: 40px;
      margin-bottom: 20px;
    }
    .check-wrap {
      position: absolute;
      top:0;
      left:5px;
      .check-box {
        width: 40px;
        height: 25px;
      }
    }
    .sort-input {
      position: absolute;
      right: 20px;
      top:15px;
      width: 80px;
    }
    .dash-border {
      border: 3px dashed red;
    }
    .card-item {
      position: relative;
      width: 360px;
      border: 1px solid #d3d6db;
      border-radius: 6px;
      background-color: #fff;
      margin-bottom: 30px;
      min-height: 400px;
      .cancelBorder{
        outline:none;
        border:none;
        width:300px;
        height:200px;
        resize:none;
      }
      .textarea{
        width:300px;
        height:300px;
      }
      .textContent{
        margin: 100px 30px 0 30px;
        /*margin-bottom: 100px;*/
      }
      .textButton{
        position: absolute;
        bottom:20px;
        right: 20px;
      }
      .insertText{
        transition: .3s;
        position: absolute;
        top:0;
        left:0;
        display: none;
      }
      .insertVote{
        transition: .3s;
        position: absolute;
        top:0;
        left:85px;
        display: none;
      }
      .card-tip {
        position: absolute;
        top:0px;
        right: 65px;
        color:red;
      }
      .inappropriate {
        position: absolute;
        top:0px;
        right:0;
        width: 60px;
        height: 30px;
        background-color: #ed6c63;
        color:#fff;
        line-height: 30px;
        text-align: center;
        border-radius: 5px;
      }
      .card-head {
        height: 45px;
        padding: 20px 25px 13px;
        .card-type {
          .pic,.article {
            display: inline-block;
            width: 45px;
            height: 25px;
            line-height: 25px;
            background-color: #42afe3;
            border-radius: 3px;
            color: #fff;
            text-align: center;
          }
          .article {
            background-color: #97cd76;
          }
        }
        .card-ID {
          margin-left: 20px;
        }
      }
      .card-content {
        padding: 10px 20px;
        .blogger-info {
          .avatar {
            display: inline-block;
            width:50px;
            height: 50px;
            border-radius: 100%;
            overflow: hidden;
            img {
              width:100%;
              height:100%;
              object-fit: cover;
              border-radius: 50%;
              vertical-align: middle;
            }
          }
          .blogger-name {
            font-size: 18px;
            color:#000;
            margin-left: 20px;
            position: relative;
            top: -20px;
          }
        }
        .article-textarea {
          margin-top: 10px;
          font-size: 15px;
          line-height: 24px;
          width: 100%;
          height: 75px;
          border: none;
          outline:none;
          resize: none;
        }
        .article-imgs {
          .img-item {
            float:left;
            width:150px;
            max-height: 205px;
            overflow: hidden;
            margin-left: 5px;
            margin-top: 5px;
            position: relative;
            img {
              width:100%;
              height:100%;
              object-fit: cover;
              vertical-align: middle;
            }
            .score {
              position: absolute;
              height: 18px;
              line-height: 18px;
              text-align: center;
              /*border-radius: 100%;*/
              background: rgba(0,0,0,.7);
              font-size: 12px;
              font-weight: bold;
              color:#fff;
              z-index:1;
              cursor: pointer;
            }
            .code-review {
              position: absolute;
              top:0;
              right:0;
              z-index: 1;
              color:rgba(0,0,0,.5);
              cursor: pointer;
            }
          }
        }
      }
      .card-time {
        padding: 10px 20px;
        box-sizing: border-box;
        .publish-time,.verify-time {
          margin-left: 10px;
          color:#1e88e5;
        }
        .verify-time {
          color:#4dc340;
        }
      }
      .card-goods {
        display: flex;
        padding-left: 20px;
        justify-content: space-between;
        .button {
          margin-bottom: 20px;
          margin-right: 20px;
          position: relative;
          .num-icon {
            position: absolute;
            padding: 0 3px;
            height:15px;
            background-color: #ed6c63;
            color:#fff;
            top:-10px;
            right:0;
            border-radius: 15px;
            font-size: 12px;
            text-align: center;
            line-height: 15px;
          }
        }

      }
      .wait-online {
        display: inline-block;
        color:red;
        margin-top: 6px;
      }
      .card-btn {
        display: flex;
        justify-content: space-between;
        padding: 20px;
        padding-top: 0;
      }
      .card-data {
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding-bottom: 20px;
      }
      .card-tags {
        padding: 0 20px 20px;
        .tag-container {
          .button {
            margin-left: 5px;
          }
          .tag {
            border-radius: 5px;
            margin-left: 5px;
            margin-bottom: 5px;
          }
        }
      }
      .btn-width {
        width: 55px;
      }
    }
    .card-item:hover{
      .insertText{
        transition: 1s;
        position: absolute;
        display: block;
        top:-33px;
        left:0;
      }
      .insertVote{
        transition: 1s;
        position: absolute;
        display: block;
        top:-33px;
        left:85px;
      }
    }
  }
  .vote-card{
    display: block;
    /*background: #fff;*/
    /*border:1px solid #b4bccc;*/
    /*border-radius: 5px;*/
    padding: 20px 30px 20px;
    .vote-head{
      overflow: hidden;
      margin-bottom: 20px;
    }
    .vote-tab{
      padding: 10px 0 10px;
      span{
        font-size: 16px;
        color: #000;
        margin-right: 20px;
      }
      .color{
        color: #666;
      }
      span.vote-active{
        color: blue;
      }
    }

  }
  .vote-title{
    color:#337ab7;
    font-weight: bold;
    font-size: 16px;
    .title-con{
      font-weight: bold;
      color: #000;
    }
  }
  .vote-content{
    overflow: hidden;
    .vote-type{
      width:250px;
      color: #000;
      p{
        margin-top: 20px;
      }
    }
    .vote-options{
      overflow: hidden;
      width:100%;
      font-weight: bold;
      color: #000;
      .vote-item{
        overflow: hidden;
        padding: 5px 0 10px;
        .ticket{
          margin-top: -10px;
          margin-left: 5px;
          width:50px
        }
      }
      .vote-progress{
        width:180px;
        height:8px;
        overflow: hidden;
        background: #ccc;
        .true{
          height:8px;
          background: #445588;
        }
        .fake{
          height:8px;
          background: #f58a0f;
        }
      }
    }

  }
</style>
